import { useState } from 'react';
import { useTrainerClients } from '../../api/queries';
import { QueryBoundary } from '../../components/QueryBoundary';
import { PageHeader } from '../../components/PageHeader';
import { useTranslation } from '../../i18n/I18nProvider';
import { clientFlags } from './flags';
import { ClientRow, Input, SkeletonList } from '../../ui';

export function TrainerClients() {
  const { t } = useTranslation();
  const query = useTrainerClients();
  const [filter, setFilter] = useState('');

  return (
    <>
      <PageHeader eyebrow={t('shell.trainer')} title={t('trainer.clients')} />
      <Input
        id="client-filter"
        className="mb-4"
        placeholder={t('trainer.clients')}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
      <QueryBoundary
        query={query}
        skeleton={<SkeletonList rows={5} />}
        isEmpty={(d) => d.items.length === 0}
        empty={{ message: t('empty.noClients') }}
      >
        {(data) => {
          const rows = data.items.filter((c) =>
            `${c.name} ${c.email}`.toLowerCase().includes(filter.toLowerCase()),
          );
          return (
            <ul className="flex flex-col gap-3">
              {rows.map((c) => (
                <li key={c.id}>
                  <ClientRow
                    name={c.name}
                    to={`/trener/klijenti/${c.id}`}
                    subtitle={c.programName ?? c.email}
                    flags={clientFlags(c, t)}
                    consistencyLabel={`${c.consistency.done}/${c.consistency.planned}`}
                  />
                </li>
              ))}
            </ul>
          );
        }}
      </QueryBoundary>
    </>
  );
}
